export const engagementBrazeReportDashboardType = "/engagement/braze_report_dashboard/:type";
